module.exports = __webpack_public_path__ + "static/media/ico_preorder.7ad79437.svg";